const NotificationService = require("./services/NotificationService");
const AutoFocusService = require("./services/AutoFocusService");

import { getStyle } from "./helper/dom";
import { detectPassiveEvents } from "./helper/featureDetect";

// Frontend end scripts
function CeresMain()
{
    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach((el) =>
    {
        $(el).tooltip();
    });

    $(function()
    {
        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        window.addEventListener(
            "scroll",
            function()
            {
                if (isDesktop)
                {
                    if ($(window).scrollTop() > offset)
                    {
                        $(".back-to-top").fadeIn(duration);
                    }
                    else
                    {
                        $(".back-to-top").fadeOut(duration);
                    }
                }
            },
            detectPassiveEvents() ? { passive: true } : false
        );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        window.addEventListener("load", function()
        {
            $(".button-to-copy").on("click", function()
            {
                const uuId = $(this).attr("data-uuid");

                const codeElement = $(".button-to-copy .code_" + uuId);
                const copiedElement = $(".button-to-copy .copied_" + uuId);
                const copyIconElement = $(".button-to-copy .copy_icon_" + uuId);
                const copiedIconElement = $(".button-to-copy .copied_icon_" + uuId);
                const textToCopy = codeElement.text();

                navigator.clipboard.writeText(textToCopy);
                codeElement.css("display", "none");
                copiedElement.css("display", "inline");
                copyIconElement.css("display", "none");
                copiedIconElement.css("display", "inline");

                setTimeout(function()
                {
                    codeElement.css("display", "inline");
                    copiedElement.css("display", "none");
                    copyIconElement.css("display", "inline");
                    copiedIconElement.css("display", "none");
                }, 1000);
            });

            $(".back-to-top").on("click", function(event)
            {
                event.preventDefault();

                $("html, body").animate({ scrollTop: 0 }, duration);

                return false;
            });

            $("#accountMenuList").on("click", function()
            {
                $("#countrySettings").collapse("hide");
                $("#currencySelect").collapse("hide");
            });

            $(".language-btn").on("click", function()
            {
                $(this).next(".menu-list").toggleClass("menu-list-active");
            });

            let lastScrollTop = 0;
            const header = $("#header");
            const headerHeight = header.outerHeight();
            const reviewsBadge = $("#google-customer-reviews").css({
                opacity: 0,
                transform: "translateY(100%)"
            });

            $(window).on("scroll", function()
            {
                const st = $(this).scrollTop();

                if (st > lastScrollTop && st > headerHeight)
                {
                    header.css("top", -1 * headerHeight);
                }
                else
                {
                    header.css("top", 0);
                }

                if (st > lastScrollTop)
                {
                    reviewsBadge.css({ opacity: 0, transform: "translateY(100%)" });
                }
                else
                {
                    if (st < $(document).height() - $(window).height() - 20)
                    {
                        reviewsBadge.css({ opacity: 1, transform: "translateY(0)" });
                    }
                }
                lastScrollTop = st;
            });
        });

        const progressLoader = $("#progress-loader");

        $(window).on("beforeunload", function()
        {
            progressLoader.css("display", "block");
        });

        $(function()
        {
            progressLoader.css("display", "none");
        });

        $(window).on("load", function()
        {
            setTimeout(function()
            {
                progressLoader.css("display", "none");
            }, 10);
        });

        $(window).on("pagehide", function()
        {
            progressLoader.css("display", "none");
        });

        $("#navigation-open-btn").on("click", function()
        {
            $("#main-navigation-wrapper").addClass("mobile-active");
            $("body").addClass("mobile-menu-active");
        });

        $(document).on("click", function(event)
        {
            if (
                !$(event.target).closest("#account-box").length &&
        !$(event.target).is("#account-btn")
            )
            {
                $("#account-box").hide();
            }
        });

        $("#account-btn").on("click", function(event)
        {
            event.stopPropagation();
            $("#account-box").toggle();
        });

        function updateCarouselVisibility(carousel, leftArrow, rightArrow)
        {
            if (carousel[0].scrollWidth <= carousel.parent().width())
            {
                rightArrow.prop("disabled", true);
            }
            else
            {
                rightArrow.prop("disabled", false);
            }
            if (carousel.scrollLeft() <= 10)
            {
                leftArrow.prop("disabled", true);
            }
            else
            {
                leftArrow.prop("disabled", false);
            }
            if (
                carousel.scrollLeft() >=
        carousel[0].scrollWidth - carousel.parent().width() - 10
            )
            {
                rightArrow.prop("disabled", true);
            }
            else
            {
                rightArrow.prop("disabled", false);
            }
        }

        $(".morgenland-carousel").each(function()
        {
            const carousel = $(this);
            const buttons = carousel
                .closest(".morgenland-carousel-wrapper")
                .find(".item-button");
            const leftArrow = carousel.siblings(".button-prev");
            const rightArrow = carousel.siblings(".button-next");

            updateCarouselVisibility(carousel, leftArrow, rightArrow);

            buttons.each(function()
            {
                $(this).on("click", function()
                {
                    const buttonId = $(this).data("id");
                    const direction = buttonId === "prev" ? -1 : 1;
                    const scrollOffset = (carousel[0].clientWidth * direction) / 2;

                    carousel.animate(
                        {
                            scrollLeft: "+=" + scrollOffset
                        },
                        {
                            duration: 300,
                            complete: function()
                            {
                                updateCarouselVisibility(carousel, leftArrow, rightArrow);
                            }
                        }
                    );
                });
            });

            carousel.on("scroll", function()
            {
                updateCarouselVisibility(carousel, leftArrow, rightArrow);
            });
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(
                new CustomEvent("updateStickyContainer", {
                    bubbles: true
                })
            );
        });
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach((el) =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
